import { render, staticRenderFns } from "./Silhouette.vue?vue&type=template&id=aacc1798"
import script from "./Silhouette.vue?vue&type=script&lang=js"
export * from "./Silhouette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports